
define(
	'Ames.CanonicalOverride.CanonicalOverride'
,   [
		'Ames.CanonicalOverride.CanonicalOverride.View'
	]
,   function (
		CanonicalOverrideView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
		}
	};
});
